import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import {
  getCurrentPage,
  getSize,
  setTableCurrentPage,
  setTablePagination,
} from 'redux/slices/tableConfig';

import { notificationDataService } from 'services/notification.service';

import { useFetch } from 'hooks';

interface Notification {
  id: string;
  season: string;
  seasonLine: string;
  title: { it: string; en: string };
  shortDescription: { it: string; en: string };
  status: string;
  isPublished: boolean;
  createdAt: string;
  action: string[];
}

const useNotifications = () => {
  const dispatch = useAppDispatch();
  const page = useAppSelector(getCurrentPage);
  const size = useAppSelector(getSize);

  const [notifications, setNotifications] = useState<Notification[]>([]);

  const { data, refetch, isLoading } = useFetch(
    () => notificationDataService.getAll(undefined, { page, size }),
    [page, size]
  );

  useEffect(() => {
    if (data) {
      const { totalElements, empty } = data;

      if (totalElements > 0 && empty) {
        dispatch(setTableCurrentPage(0));
        return;
      }

      if (data.content) {
        const mapped = data.content.map((item: Omit<Notification, 'action'>) => ({
          ...item,
          action: ['edit', 'delete'],
        }));
        setNotifications(mapped);
      }

      dispatch(setTablePagination({ totalPages: data.totalPages }));
    }
  }, [data, dispatch]);

  return {
    notifications,
    refetchNotifications: refetch,
    isLoading,
  };
};

export { useNotifications };
